import React, { useState, useEffect } from 'react'
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  TextField,
  Box,
  Button,
  Typography,
  Grid,
  CircularProgress,
  Fade,
  Paper,
  InputAdornment,
} from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import SaveIcon from '@material-ui/icons/Save'
import DeleteIcon from '@material-ui/icons/Delete'
import PictureDialog from './PictureDialog'
import { Alert, AlertTitle } from '@material-ui/lab'
import AccountCircle from '@material-ui/icons/AccountCircle'
import HelpIcon from '@material-ui/icons/Help'
import CakeIcon from '@material-ui/icons/Cake'
import ClockIcon from '@material-ui/icons/Timelapse'
import Cleave from 'cleave.js/react'

import { db, functions } from '../firebase'
import moment from 'moment'
import 'moment/locale/th'
moment().locale('th')

let pictureReader, billReader
if (typeof window !== 'undefined') {
  pictureReader = new FileReader()
  billReader = new FileReader()
}

function DateTextField(props) {
  const { options, inputRef, ...other } = props
  return (
    <Cleave
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null)
      }}
      options={{
        date: true,
        delimiter: '-',
        datePattern: ['d', 'm', 'Y'],
      }}
    />
  )
}

function TimeTextField(props) {
  const { options, inputRef, ...other } = props
  return (
    <Cleave
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null)
      }}
      options={{
        time: true,
        timePattern: ['h', 'm'],
      }}
    />
  )
}

const Form = () => {
  const [data, setData] = useState({
    fullname: '',
    birthday: {
      date: '',
      time: '',
    },
    gender: 'female',
    promotion: 'promotion1',
    question: {
      question1: '',
      question2: '',
      question3: '',
      question4: '',
      question5: '',
    },
    picture: '',
    pictures: [],
    bill: '',
  })
  const [errors, setErrors] = useState({
    fullname: '',
    question1: '',
    question2: '',
    question3: '',
    question4: '',
    question5: '',
    picture: '',
    bill: '',
  })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    pictureReader.addEventListener('load', () => {
      setData({ ...data, picture: pictureReader.result })
    })
    billReader.addEventListener('load', () => {
      setData({ ...data, bill: billReader.result })
    })
  }, [data])

  const onChangePicture = async (e) => {
    setErrors({ ...errors, picture: '' })
    e.persist()
    pictureReader.readAsDataURL(e.target.files[0])
  }

  const onChangeBill = (e) => {
    setErrors({ ...errors, bill: '' })
    e.persist()
    billReader.readAsDataURL(e.target.files[0])
  }

  const handlePerson = (title, key) => {
    let arr = [...data.pictures]
    arr[key].title = title

    setData({ ...data, pictures: arr })
  }

  const onChangePictures = (e) => {
    e.persist()
    let arr = []

    for (let i = 0; i < e.target.files.length; i++) {
      let picturesReader = new FileReader()
      picturesReader.readAsDataURL(e.target.files[i])
      picturesReader.onload = function () {
        arr[i] = { image: picturesReader.result, title: '' }

        if (e.target.files.length === i + 1 && e.target.files.length < 6) {
          setData({ ...data, pictures: arr })
        }
      }
    }
  }

  const clearData = () => {
    setData({
      fullname: '',
      birthday: {
        date: '',
        time: '',
      },
      gender: 'female',
      promotion: 'promotion1',
      question: {
        question1: '',
        question2: '',
        question3: '',
        question4: '',
        question5: '',
      },
      picture: '',
      pictures: [],
      bill: '',
    })
  }

  const handleSubmit = async () => {
    const {
      fullname,
      question,
      promotion,
      picture,
      bill,
      birthday: { date, time },
    } = data

    const { question1, question2, question3, question4, question5 } = question

    if (
      !fullname ||
      !question1 ||
      !question2 ||
      !question3 ||
      (promotion === 2 && (!question4 || !question5)) ||
      !picture ||
      !bill ||
      !date ||
      !time
    ) {
      let validate = {}
      if (!fullname) {
        validate.fullname = 'กรุณากรอกชื่อและนามสกุล'
      }
      if (!question.question1) {
        validate.question1 = 'กรุณาตั้งคำถาม'
      }
      if (!question.question2) {
        validate.question2 = 'กรุณาตั้งคำถาม'
      }
      if (!question.question3) {
        validate.question3 = 'กรุณาตั้งคำถาม'
      }
      if (promotion === 'promotion2') {
        if (!question.question4) {
          validate.question4 = 'กรุณาตั้งคำถาม'
        }
        if (!question.question5) {
          validate.question5 = 'กรุณาตั้งคำถาม'
        }
      }
      if (!picture) {
        validate.picture = 'กรุณาอัพโหลดรูปของคุณ'
      }
      if (!bill) {
        validate.bill = 'กรุณาอัพโหลดรูปใบเสร็จ'
      }
      if (!date) {
        validate.date = 'กรุณากรอกวันเกิด'
      }
      if (!time) {
        validate.time = 'กรุณากรอกเวลาเกิด'
      }
      setErrors(validate)
      return
    }

    setLoading(true)

    const docData = {
      fullname: data.fullname,
      gender: data.gender,
      dateCreated: new Date(),
      birthday: data.birthday.date + ' ' + data.birthday.time,
      promotion: data.promotion,
      question: data.question,
      status: 'รอการตรวจสอบ',
      answer: {
        answer1: '',
        answer2: '',
        answer3: '',
        answer4: '',
        answer5: '',
      },
    }

    const docRef = await db.collection('billings').doc()
    if (docRef.id) {
      docRef.set(docData)
      setLoading(false)
      setSuccess(true)
      setTimeout(() => {
        setSuccess(false)
      }, 3000)
      clearData()
      const createBillingCallable = functions.httpsCallable('createBilling')
      createBillingCallable({ ...data, id: docRef.id })
    }
  }

  return (
    <Grid container spacing={2} style={{ justifyContent: 'center' }}>
      <Grid item sm={6} md={4}>
        <Box component={Paper} p={3}>
          <FormControl
            component="form"
            fullWidth
            id="form-question"
            className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
          >
            <Box mb={2}>
              <TextField
                required
                id="fullname"
                label="ชื่อ-สกุล"
                placeholder="ชื่อ-สกุล (ภาษาไทย)"
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  ),
                }}
                value={data.fullname}
                onChange={(event) => {
                  setData({ ...data, fullname: event.target.value })
                  setErrors({ ...errors, fullname: '' })
                }}
                error={!!errors.fullname}
                helperText={errors.fullname}
              />
            </Box>
            <Box mb={2}>
              <TextField
                style={{ marginBottom: 16 }}
                fullWidth
                required
                label="วันเกิด"
                id="date"
                placeholder="วัน/เดือน/ปี (พ.ศ.)"
                onChange={(event) =>
                  setData({
                    ...data,
                    birthday: { ...data.birthday, date: event.target.value },
                  })
                }
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputComponent: DateTextField,
                  startAdornment: (
                    <InputAdornment position="start">
                      <CakeIcon />
                    </InputAdornment>
                  ),
                }}
                error={!!errors.date}
                helperText={errors.date}
              />

              <TextField
                fullWidth
                required
                label="เวลาเกิด"
                id="time"
                placeholder="00:00"
                onChange={(event) =>
                  setData({
                    ...data,
                    birthday: { ...data.birthday, time: event.target.value },
                  })
                }
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputComponent: TimeTextField,
                  startAdornment: (
                    <InputAdornment position="start">
                      <ClockIcon />
                    </InputAdornment>
                  ),
                }}
                error={!!errors.time}
                helperText={errors.time}
              />
            </Box>
            <Box mb={2}>
              <FormControl required component="fieldset">
                <FormLabel component="legend">เพศ</FormLabel>
                <RadioGroup
                  aria-label="gender"
                  name="gender1"
                  value={data.gender}
                  onChange={(event) =>
                    setData({ ...data, gender: event.target.value })
                  }
                >
                  <FormControlLabel
                    value="female"
                    control={<Radio color="primary" />}
                    label="หญิง"
                  />
                  <FormControlLabel
                    value="male"
                    control={<Radio color="primary" />}
                    label="ชาย"
                  />
                  <FormControlLabel
                    value="other"
                    control={<Radio color="primary" />}
                    label="ไม่ระบุ"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box mb={2}>
              <FormControl required component="fieldset">
                <FormLabel component="legend">โปรโมชั่น</FormLabel>
                <RadioGroup
                  aria-label="promotion"
                  name="promotion"
                  value={data.promotion}
                  onChange={(event) =>
                    setData({ ...data, promotion: event.target.value })
                  }
                >
                  <FormControlLabel
                    value="promotion1"
                    control={<Radio color="primary" />}
                    label="3 คำถาม / 99 บาท"
                  />
                  <FormControlLabel
                    value="promotion2"
                    control={<Radio color="primary" />}
                    label="5 คำถาม / 159 บาท"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box mb={2}>
              <TextField
                required
                id="question1"
                label="คำถามที่ 1"
                placeholder="ตั้งคำถามที่คุณอยากรู้"
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                value={data.question.question1}
                onChange={(event) => {
                  setData({
                    ...data,
                    question: {
                      ...data.question,
                      question1: event.target.value,
                    },
                  })
                  setErrors({ ...errors, question1: '' })
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <HelpIcon />
                    </InputAdornment>
                  ),
                }}
                error={!!errors.question1}
                helperText={errors.question1}
              />
              <TextField
                required
                id="question2"
                label="คำถามที่ 2"
                placeholder="ตั้งคำถามที่คุณอยากรู้"
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                value={data.question.question2}
                onChange={(event) => {
                  setData({
                    ...data,
                    question: {
                      ...data.question,
                      question2: event.target.value,
                    },
                  })
                  setErrors({ ...errors, question2: '' })
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <HelpIcon />
                    </InputAdornment>
                  ),
                }}
                error={!!errors.question2}
                helperText={errors.question2}
              />
              <TextField
                required
                id="question3"
                label="คำถามที่ 3"
                placeholder="ตั้งคำถามที่คุณอยากรู้"
                fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                value={data.question.question3}
                onChange={(event) => {
                  setData({
                    ...data,
                    question: {
                      ...data.question,
                      question3: event.target.value,
                    },
                  })
                  setErrors({ ...errors, question3: '' })
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <HelpIcon />
                    </InputAdornment>
                  ),
                }}
                error={!!errors.question3}
                helperText={errors.question3}
              />

              {data.promotion === 'promotion2' && (
                <>
                  <TextField
                    required
                    id="question4"
                    label="คำถามที่ 4"
                    placeholder="ตั้งคำถามที่คุณอยากรู้"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={data.question.question4}
                    onChange={(event) => {
                      setData({
                        ...data,
                        question: {
                          ...data.question,
                          question4: event.target.value,
                        },
                      })
                      setErrors({ ...errors, question4: '' })
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <HelpIcon />
                        </InputAdornment>
                      ),
                    }}
                    error={!!errors.question4}
                    helperText={errors.question4}
                  />
                  <TextField
                    required
                    id="question5"
                    label="คำถามที่ 5"
                    placeholder="ตั้งคำถามที่คุณอยากรู้"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <HelpIcon />
                        </InputAdornment>
                      ),
                    }}
                    value={data.question.question5}
                    onChange={(event) => {
                      setData({
                        ...data,
                        question: {
                          ...data.question,
                          question5: event.target.value,
                        },
                      })
                      setErrors({ ...errors, question5: '' })
                    }}
                    error={!!errors.question5}
                    helperText={errors.question5}
                  />
                </>
              )}
            </Box>
            <Box mb={2}>
              <Typography
                style={{ paddingLeft: 8, marginBottom: 8 }}
                variant="caption"
                component="p"
              >
                รูปภาพของคุณ *
              </Typography>
              <Box textAlign="center">
                {data.picture && (
                  <PictureDialog
                    selectedValue="picture"
                    fullname={data.fullname}
                    picture={data.picture}
                  />
                )}
                <Button
                  variant="contained"
                  component="label"
                  color="default"
                  startIcon={<CloudUploadIcon />}
                  fullWidth
                >
                  Upload
                  <input
                    type="file"
                    onChange={onChangePicture}
                    style={{ display: 'none' }}
                    required
                  />
                </Button>
              </Box>
            </Box>
            <Box mb={2}>
              <Typography
                style={{ paddingLeft: 8, marginBottom: 8 }}
                variant="caption"
                component="p"
              >
                รูปภาพของคุณ *{' '}
                <Typography variant="caption" component="small">
                  (อัพโหลดได้ไม่เกิน 5 รูปภาพ)
                </Typography>
              </Typography>
              <Box textAlign="center">
                {data.pictures.length > 0 && (
                  <Grid container spacing={2} alignItems="center">
                    {data.pictures.map((other, key) => (
                      <Grid
                        item
                        xs={12}
                        xl={4}
                        key={`person-${key}`}
                        className="lg:w-1/3 w-full px-3"
                      >
                        <Box p={2}>
                          <PictureDialog
                            selectedValue="picture"
                            fullname={`person_${key + 1}`}
                            picture={other.image}
                          />
                          <TextField
                            required
                            placeholder="เกี่ยวข้องเป็น"
                            fullWidth
                            margin="normal"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={data.pictures[key].title}
                            onChange={(event) =>
                              handlePerson(event.target.value, key)
                            }
                          />
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                )}
                <Button
                  variant="contained"
                  component="label"
                  color="default"
                  startIcon={<CloudUploadIcon />}
                  fullWidth
                >
                  Upload
                  <input
                    type="file"
                    onChange={onChangePictures}
                    style={{ display: 'none' }}
                    required
                    multiple
                  />
                </Button>
              </Box>
            </Box>
            <Box mb={2}>
              <Typography
                style={{ paddingLeft: 8, marginBottom: 8 }}
                variant="caption"
                component="p"
              >
                อัพโหลดใบเสร็จ *
              </Typography>
              <Box textAlign="center">
                {data.bill && (
                  <PictureDialog fullname={data.fullname} picture={data.bill} />
                )}
                <Button
                  variant="contained"
                  component="label"
                  color="default"
                  startIcon={<CloudUploadIcon />}
                  fullWidth
                >
                  Upload
                  <input
                    type="file"
                    onChange={onChangeBill}
                    style={{ display: 'none' }}
                    required
                  />
                </Button>
              </Box>
            </Box>
            {errors.picture && (
              <Fade in={!!errors.picture}>
                <Alert severity="error" style={{ marginBottom: 8 }}>
                  <AlertTitle>เกิดข้อผิดพลาด</AlertTitle>
                  นี่คือการแจ้งเตือนว่าเกิดข้อผิดพลาด —{' '}
                  <strong>{errors.picture}</strong>
                </Alert>
              </Fade>
            )}
            {errors.bill && (
              <Fade in={!!errors.bill} style={{ marginBottom: 8 }}>
                <Alert severity="error">
                  <AlertTitle>เกิดข้อผิดพลาด</AlertTitle>
                  นี่คือการแจ้งเตือนว่าเกิดข้อผิดพลาด —{' '}
                  <strong>{errors.bill}</strong>
                </Alert>
              </Fade>
            )}
            {success && (
              <Fade in={success} style={{ marginBottom: 8 }}>
                <Alert severity="success">
                  <AlertTitle>ส่งข้อมูลสำเร็จ</AlertTitle>
                  นี่คือการแจ้งเตือนว่าส่งข้อมูลสำเร็จ —{' '}
                  <strong>กรุณารอการติดต่อกลับจากทีมงานดวงทูเดย์!</strong>
                </Alert>
              </Fade>
            )}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              py={3}
            >
              {!loading ? (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    onClick={() => handleSubmit()}
                    style={{ marginRight: 8 }}
                  >
                    ส่งข้อมูล
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<DeleteIcon />}
                    onClick={() => clearData()}
                  >
                    ล้างข้อมูล
                  </Button>
                </>
              ) : (
                <CircularProgress />
              )}
            </Box>
          </FormControl>
        </Box>
      </Grid>
    </Grid>
  )
}

export default Form
